module.exports = __webpack_public_path__ + "img/badge-hd-fill.ff90f65c.svg";